import { render, staticRenderFns } from "./DefinitionParameterEditForm.vue?vue&type=template&id=5279acf4&scoped=true"
import script from "./DefinitionParameterEditForm.vue?vue&type=script&lang=js"
export * from "./DefinitionParameterEditForm.vue?vue&type=script&lang=js"
import style0 from "./DefinitionParameterEditForm.vue?vue&type=style&index=0&id=5279acf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279acf4",
  null
  
)

export default component.exports